import {GetMatchingDataFromApiResponseConfigInterface} from '../interfaces/helpers';

export const UPDATE_MEMBER_POINTS_FAILURE: GetMatchingDataFromApiResponseConfigInterface[] =
  [
    {
      apiResponses: [
        {
          success: false,
          code: 400,
          errorMessage: {
            VARIANT_MAP_COMPARE_TYPE: 'partialMatch',
            value: 'exceeds the maximum daily points limit',
          },
        },
      ],
      message:
        'This member will exceed the daily points of {{dailyCapLimit}} after this transaction. Please review again.',
    },
    {
      apiResponses: [
        {
          success: false,
          code: 400,
          errorMessage: 'Merchant not found',
        },
        {
          success: false,
          code: 400,
          errorMessage: 'Point value must be greater than 0',
        },
        {
          success: false,
          code: 400,
          errorMessage: 'Point amount must be greater than 0',
        },
      ],
      message:
        'This transaction has missing information. Please amend before approving.',
    },
  ];

export const ISLANDER_MEMBER_DETAIL_FAILURE_ERROR_CODE = {
  INVALID_FIELDS_WITH_ERRORS_MESSAGES: 4010,
};

export const LIMITED_EVENT_FAILURE_ERROR_CODE = {
  SELECTED_MERCHANT_PART_OF_ACTIVE_EVENT: 5002,
};
